import {
    AlarmModeEnum,
    BatteryStoreModeEnum, CameraMode,recordingState, ControlSource, DistanceLimitStatusEnum, DrcStateEnum, DroneBatteryStateEnum,
    DroneInDockEnum, FourGLinkStateEnum, LinkWorkModeEnum,
    NetworkStateTypeEnum, NightLightsStateEnum, ObstacleAvoidanceStatusEnum,
    RainfallEnum, SdrLinkStateEnum
  } from "@/types/enum";
  
  
  
  export enum EModeCode {
    Standby,
    Preparing,
    Ready,
    Manual,
    Automatic,
    Waypoint,
    Panoramic,
    ActiveTrack,
    ADSB,
    ReturnToHome,
    Landing,
    ForcedLanding,
    ThreeBladesLanding,
    Upgrading,
    Disconnected,
  }
  
  export enum EGear {
    A,
    P,
    NAV,
    FPV,
    FARM,
    S,
    F,
    M,
    G,
    T
  }
  
  export enum EDockModeCode {
    Disconnected = -1,
    Idle,
    Debugging,
    Remote_Debugging,
    Upgrading,
    Working,
  }
  
  
  export interface GatewayOsd {
    capacityPercent: string,
    transmissionSignalQuality: string,
    longitude: number,
    latitude: number,
  }
  
  export interface DockBasicOsd {
    networkState?: {
      type: NetworkStateTypeEnum,
      quality: number,
      rate: number,
    },
    droneChargeState?: {
      state: number,
      capacityPercent: number,
    },
    droneInDock: DroneInDockEnum,
    rainfall: RainfallEnum,
    windSpeed: number,
    environmentTemperature: number,
    temperature: number,
    humidity: number,
    latitude: number,
    longitude: number,
    height: number,
    alternateLandPoint?: {
      latitude: number,
      longitude: number,
      height: number,
      safeLandHeight: number,
      isConfigured: number
    }
    firstPowerOn: number,
    positionState?: {
      gpsNumber: number,
      isFixed: number,
      rtkNumber: number,
      isCalibration: number,
      quality: number,
    },
    storage?: {
      total: number,
      used: number,
    },
    mode_code: number,
    coverState: number,
    supplementLightState: number,
    emergencyStopState: number,
    airConditioner?: {
      airConditionerState: number,
      switchTime: number,
    }
    batteryStoreMode?: BatteryStoreModeEnum; // 电池保养(存储)模式
    alarmState?: AlarmModeEnum; // 机场声光报警状态
    putterState: number,
    subDevice?: {
      deviceSn?: string,
      deviceModelKey?: string,
      deviceOnlineStatus: number,
      devicePaired: number,
    },
    // live_capacity?: LiveCapacity; // 直播能力
    // live_status?: Array<LiveStatus>; // 直播状态
  }
  
  export interface DockLinkOsd {
    drcState: DrcStateEnum,
    flightTaskPrepareCapacity: number,
    flightTaskStepCode: number,
    mediaFileDetail?: {
      remainUpload: number
    },
    sdr: {
      upQuality: string,
      downQuality: string,
      frequencyBand: number,
    },
    wirelessLink?:{ // 图传链路<会包括4G和sdr信息
      dongleNumber: number, // dongle 数量
      ['4gLinkState']: FourGLinkStateEnum, // 4gLink_state
      sdrLinkState: SdrLinkStateEnum, // sdr链路连接状态
      linkWorkMode: LinkWorkModeEnum, // 图传链路模式
      sdrQuality: number, // sdr信号质量 0-5
      ['4gQuality']: number, // 4G信号质量 0-5
      ['4gFreqBand']: number,
      ['4gGndQuality']: number,
      ['4gUavQuality']: number,
      sdrFreqBand: number,
    }
  }

  
// domain
export enum DOMAIN {
  DRONE = '0', // 飞行器
  PAYLOAD = '1', // 负载
  RC = '2', // 遥控
  DOCK = '3', // 机场
}

// DJI飞机类型
export enum DRONE_TYPE {
  M30 = 67,
  M300 = 60,
  Mavic3EnterpriseAdvanced= 77,
  M350 = 89,
  M3D = 91,
}

// DJI负载类型枚举值
export enum PAYLOAD_TYPE {
  FPV = 39,
  H20 = 42,
  H20T = 43,
  H20N = 61,
  EP600 = 50,
  EP800 = 90742,
  M30D = 52,
  M30T = 53,
  XT2 = 26,
  XTS = 41,
  Z30 = 20,
  DockTopCamera = 165,

  M3E = 66,
  M3T = 67,
  M3D = 80,
  M3TD = 81,
  // UNKNOWN = 65535
}

// RC type
export enum RC_TYPE {
  RC = 56,
  RCPlus = 119,
  RC144 = 144,
}

// DOCK type
export enum DOCK_TYPE {
  Dock = 1,
  Dock2 = 2,
}

// 设备sub_type 从0升序
export enum DEVICE_SUB_TYPE {
  ZERO,
  ONE,
  TWO,
  THREE,
  UNKNOWN = 65535,
}

  export const DEVICE_MODEL_KEY = {
    M30: `${DOMAIN.DRONE}-${DRONE_TYPE.M30}-${DEVICE_SUB_TYPE.ZERO}`,
    M30T: `${DOMAIN.DRONE}-${DRONE_TYPE.M30}-${DEVICE_SUB_TYPE.ONE}`,
  
    M3E: `${DOMAIN.DRONE}-${DRONE_TYPE.Mavic3EnterpriseAdvanced}-${DEVICE_SUB_TYPE.ZERO}`,
    M3T: `${DOMAIN.DRONE}-${DRONE_TYPE.Mavic3EnterpriseAdvanced}-${DEVICE_SUB_TYPE.ONE}`,
  
    M300: `${DOMAIN.DRONE}-${DRONE_TYPE.M300}-${DEVICE_SUB_TYPE.ZERO}`,
    M350: `${DOMAIN.DRONE}-${DRONE_TYPE.M350}-${DEVICE_SUB_TYPE.ZERO}`,
  
    M3D: `${DOMAIN.DRONE}-${DRONE_TYPE.M3D}-${DEVICE_SUB_TYPE.ZERO}`,
    M3TD: `${DOMAIN.DRONE}-${DRONE_TYPE.M3D}-${DEVICE_SUB_TYPE.ONE}`,
  
    FPV: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.FPV}-${DEVICE_SUB_TYPE.ZERO}`,
    H20: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.H20}-${DEVICE_SUB_TYPE.ZERO}`,
    H20T: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.H20T}-${DEVICE_SUB_TYPE.ZERO}`,
    H20N: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.H20N}-${DEVICE_SUB_TYPE.ZERO}`,
    EP600: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.EP600}-${DEVICE_SUB_TYPE.UNKNOWN}`,
    EP800: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.EP800}-${DEVICE_SUB_TYPE.ZERO}`,
    M30Camera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M30D}-${DEVICE_SUB_TYPE.ZERO}`,
    M30TCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M30T}-${DEVICE_SUB_TYPE.ZERO}`,
    M30TCamera1: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M30T}-${DEVICE_SUB_TYPE.ONE}`,
    M30TCamera2: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M30T}-${DEVICE_SUB_TYPE.TWO}`,
  
    M3ECamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3E}-${DEVICE_SUB_TYPE.ZERO}`,
    M3TCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3T}-${DEVICE_SUB_TYPE.ZERO}`,
    M3DCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3D}-${DEVICE_SUB_TYPE.ZERO}`,
    M3TDCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3TD}-${DEVICE_SUB_TYPE.ZERO}`,
    M3TDCamera1:`${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3TD}-${DEVICE_SUB_TYPE.ONE}`,
    M3TDCamera2:`${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3TD}-${DEVICE_SUB_TYPE.TWO}`,
    // M3MCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.M3M}-${DEVICE_SUB_TYPE.ZERO}`,
  
    XT2: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.XT2}-${DEVICE_SUB_TYPE.ZERO}`,
    XTS: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.XTS}-${DEVICE_SUB_TYPE.ZERO}`,
    Z30: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.Z30}-${DEVICE_SUB_TYPE.ZERO}`,
    DockTopCamera: `${DOMAIN.PAYLOAD}-${PAYLOAD_TYPE.DockTopCamera}-${DEVICE_SUB_TYPE.ZERO}`,
  
    RC: `${DOMAIN.RC}-${RC_TYPE.RC}-${DEVICE_SUB_TYPE.ZERO}`,
    RCPlus: `${DOMAIN.RC}-${RC_TYPE.RCPlus}-${DEVICE_SUB_TYPE.ZERO}`,
  
    Dock: `${DOMAIN.DOCK}-${DOCK_TYPE.Dock}-${DEVICE_SUB_TYPE.ZERO}`,
    Dock2: `${DOMAIN.DOCK}-${DOCK_TYPE.Dock2}-${DEVICE_SUB_TYPE.ZERO}`,
  }

  export const DEVICE_NAME = {
    // drone
    [DEVICE_MODEL_KEY.M30]: 'M30',
    [DEVICE_MODEL_KEY.M30T]: 'M30T',
    [DEVICE_MODEL_KEY.M3E]: 'Mavic 3E',
    [DEVICE_MODEL_KEY.M3T]: 'Mavic 3T',
    // [DEVICE_MODEL_KEY.M3M]: 'Mavic 3M',
    [DEVICE_MODEL_KEY.M300]: 'M300 RTK',
    [DEVICE_MODEL_KEY.M350]: 'M350 RTK',
    [DEVICE_MODEL_KEY.M3D]: 'M3D',
    [DEVICE_MODEL_KEY.M3TD]: 'M3TD',
  
    // payload
    [DEVICE_MODEL_KEY.FPV]: 'FPV',
    [DEVICE_MODEL_KEY.H20]: 'H20',
    [DEVICE_MODEL_KEY.H20T]: 'H20T',
    [DEVICE_MODEL_KEY.H20N]: 'H20N',
    [DEVICE_MODEL_KEY.EP600]: 'P1',
    [DEVICE_MODEL_KEY.EP800]: 'L1',
    [DEVICE_MODEL_KEY.M30Camera]: 'M30 Camera',
    [DEVICE_MODEL_KEY.M30TCamera]: 'M30T Camera',
    [DEVICE_MODEL_KEY.M30TCamera1]: 'M30T Camera1',
    [DEVICE_MODEL_KEY.M30TCamera2]: 'M30T Camera2',
    [DEVICE_MODEL_KEY.M3ECamera]: 'Mavic 3E',
    [DEVICE_MODEL_KEY.M3TCamera]: 'Mavic 3T',
    // [DEVICE_MODEL_KEY.M3MCamera]: 'Mavic 3M',
    [DEVICE_MODEL_KEY.XT2]: 'XT2',
    [DEVICE_MODEL_KEY.XTS]: 'XTS',
    [DEVICE_MODEL_KEY.Z30]: 'Z30',
    [DEVICE_MODEL_KEY.DockTopCamera]: 'Dock Camera',
    [DEVICE_MODEL_KEY.M3DCamera]: 'M3D Camera',
    [DEVICE_MODEL_KEY.M3TDCamera]: 'M3TD Camera',
    [DEVICE_MODEL_KEY.M3TDCamera1]: 'M3TD Camera1',
    [DEVICE_MODEL_KEY.M3TDCamera2]: 'M3TD Camera2',
  
    // rc
    [DEVICE_MODEL_KEY.RC]: 'RC',
    [DEVICE_MODEL_KEY.RCPlus]: 'RC Plus',
  
    // dock
    [DEVICE_MODEL_KEY.Dock]: 'Dock',
    [DEVICE_MODEL_KEY.Dock2]: 'Dock2',
  }
  
  export interface MaintainStatus {
    state: number,
    lastMaintainType: number,
    lastMaintainTime: number,
    lastMaintainWorkSorties: number,
  }
  export interface DockWorkOsd {
    jobNumber: number,
    accTime: number,
    activationTime: number,
    maintainStatus?: {
      maintainStatusArray: MaintainStatus[]
    }
    electricSupplyVoltage: number,
    workingVoltage: string,
    workingCurrent: string,
    backupBattery?: {
      voltage: number,
      temperature: number,
      switch: number,
    }
    droneBatteryMaintenanceInfo?: { // 飞行器电池保养信息
      maintenanceState: DroneBatteryStateEnum, // 保养状态
      maintenanceTimeLeft: number, // 电池保养剩余时间(小时)
    }
  }
  export interface DockOsd {
    basicOsd: DockBasicOsd,
    linkOsd: DockLinkOsd,
    workOsd: DockWorkOsd
  }
  
  
  export interface DistanceLimitStatus {
    state?: DistanceLimitStatusEnum;
    distanceLimit?: number; // 限远
  }
  
  export interface ObstacleAvoidance {
    horizon?: ObstacleAvoidanceStatusEnum;// 水平避障开关
    upside?: ObstacleAvoidanceStatusEnum;// 上行方向避障开关
    downside?: ObstacleAvoidanceStatusEnum;// 下行方向避障开关
  }
  
  export interface OsdCameraLiveView {
    bottom: number,
    left: number,
    right: number,
    top: number,
  }
  export interface DeviceOsdCamera {
    cameraMode: CameraMode,
    payloadIndex: string,
    photoState: number,
    recordTime: number,
    recordingState: recordingState,
    remainPhotoNum: number,
    remainRecordDuration: number,
    liveViewWorldRegion: OsdCameraLiveView
  }
  export interface DeviceOsd {
    longitude: number,
    latitude: number,
    gear: number,
    mode_code: number,
    height: string,
    homeDistance: string,
    horizontalSpeed: string,
    verticalSpeed: string,
    windSpeed: string,
    windDirection: string,
    elevation: string,
    positionState: {
      gpsNumber: string,
      isFixed: number,
      rtkNumber: string
    },
    battery: {
      capacityPercent: string,
      landingPower: string,
      remainFlightTime: number,
      returnHomePower: string,
    },
    nightLightsState?: NightLightsStateEnum;// 夜航灯开关
    heightLimit?: number;// 限高设置
    distanceLimitStatus?: DistanceLimitStatus;// 限远开关
    obstacleAvoidance?: ObstacleAvoidance;// 飞行器避障开关设置
    cameras?: DeviceOsdCamera[]
  }
  // TODO: 设备拓扑管理优化
  // 设备osd信息
  export interface DeviceInfoType {
    gateway: GatewayOsd, // 遥控器
    dock: DockOsd, // 机场
    device: DeviceOsd, // 飞机
  }
  
  export interface PayloadInfo {
    index: number,
    model: string,
    controlSource?: ControlSource,
    payloadSn?: string,
    payloadIndex?: string,
    payloadName?: string,
  }
  export interface DeviceInfo {
    model: string
    callSign: string
    sn: string
    mode:number,
    gateway: {
      model: string,
      callSign: string,
      sn: string,
      domain: string,
    },
    payload: PayloadInfo[]
  }
  
  export interface DeviceStatus {
    sn: string,
    online_status: boolean,
    device_callsign: string,
    user_id: string,
    user_callsign: string
    bound_status: boolean,
    model: string,
    gateway_sn: string,
    domain: number
  }
  
  
  export interface GatewayOsd {
    capacity_percent: string,
    transmission_signal_quality: string,
    longitude: number,
    latitude: number,
  }
  
  export interface OsdCameraLiveView {
    bottom: number,
    left: number,
    right: number,
    top: number,
  }
  
  export interface DeviceOsdCamera {
    camera_mode: CameraMode,
    payload_index: string,
    photo_state: number,
    record_time: number,
    recording_state: recordingState,
    remain_photo_num: number,
    remain_record_duration: number,
    liveview_world_region: OsdCameraLiveView
  }
  
  // 固件升级状态
  export enum DeviceFirmwareStatusEnum {
    None = 1, // 无需升级
    ToUpgraded = 2, // 待升级
    ConsistencyUpgrade = 3, // 一致性升级
    DuringUpgrade = 4, // 升级中
  }
  
  export const DeviceFirmwareStatus = {
    [DeviceFirmwareStatusEnum.None]: '',
    [DeviceFirmwareStatusEnum.ToUpgraded]: '待升级',
    [DeviceFirmwareStatusEnum.ConsistencyUpgrade]: '一致性升级',
    [DeviceFirmwareStatusEnum.DuringUpgrade]: '升级中',
  }
  
  export interface Device {
    device_name: string,
    device_sn: string,
    nickName: string,
    firmware_version: string,
    firmware_status: DeviceFirmwareStatusEnum,
    status: string,
    workspace_name: string,
    bound_time: string,
    login_time: string,
    children?: Device[],
    domain: number,
    type: number,
    firmware_progress?: string, // 升级进度
  }
  
  export interface DeviceHms {
    hms_id: string,
    tid: string,
    bid: string,
    sn: string,
    level: number,
    module: number,
    key: string,
    message_en: string,
    message_zh: string,
    create_time: string,
    update_time: string,
    domain: number
  }
  